import { combineReducers } from 'redux';

import data from './data';
import params from './params';
// history

export default combineReducers({ data, params });
